<template>
  <action :onAction="viewUserAction">
    <template v-slot:icon><v-icon class="material-icons-outlined">info</v-icon></template>
    <template v-slot:tooltip><span>View information about the User.</span></template>
    <template v-slot:label><span>View User</span></template>
  </action>
</template>

<script>
import Component from 'vue-class-component';
import Action from '@/components/action/Action.vue';
import { Prop } from 'vue-property-decorator';

@Component({
  components: {
    Action,
  },
})
export default class ViewUserAction extends Action {
  @Prop(Function) displayViewUserDialog;
  @Prop(Object) user;

  viewUserAction() {
    this.displayViewUserDialog(this.user);
  }
}
</script>
